import { getContentByRef } from './get-content-by-ref.js';

function getVtoBanner(pageModel, ref) {
    const brVtoBanner = getContentByRef(ref, pageModel);
    if (!brVtoBanner) {
        return undefined;
    }
    return {
        title: brVtoBanner.title,
        description: brVtoBanner.description,
        image: brVtoBanner.image
    };
}

export { getVtoBanner };
//# sourceMappingURL=get-vto-banner.js.map
